$(document).ready(function() {

	
	//CERTIFICATE FORM
	var $certificate_form = $("#certificate_form");

	if($certificate_form !== undefined) {
		var response_url;
		$certificate_form.validate({
			debug: true,
            invalidHandler: function (event, validator) {
	            
            },
            submitHandler: function(form) {
		
				event.preventDefault();
				
				$certificate_form.find(':submit').prop( "disabled", true );
				$certificate_form.find(':submit').addClass('button--loading');
				
				var request_url = $certificate_form.attr('action');
				var options = {
					method: 'POST',
					body: $certificate_form.serialize()
				}
				
				fetch(request_url, options)
				.then(function(response) {
					if(response.status === 200) {
						response.blob().then(function(blob) {
							try {
								
								var file_url = window.URL.createObjectURL(blob);
	
								var file_link = document.createElement('a');
								file_link.style.display = 'none';
								file_link.href = file_url;
								file_link.download = 'TERRE-DES-FEMMES_Spendenurkunde.pdf';
								
								document.body.appendChild(file_link);
								file_link.click();
	
								window.URL.revokeObjectURL(file_url);
								updateForm($certificate_form, 'success', 'certificate_notice', 'Erfolg');
	
							}
							catch(error) {
								//alert('error 1');
								updateForm($certificate_form, 'error', 'certificate_notice', 'Fehler');
							}
						});
					}
					else {
						//alert('error 2');
						updateForm($certificate_form, 'error', 'certificate_notice', 'Fehler');
					}
				})
				.catch(function(error) {
					//alert('error 3');
					updateForm($certificate_form, 'error', 'certificate_notice', 'Fehler');
				});
			},
            errorPlacement: function (error, element) {
                if (element.attr("type") == "checkbox") {
                    if ($(element).parents('.checkbox__error-container')) {
                        error.appendTo($(element).parents('.checkbox__error-container'));
                    } else {
                        error.appendTo($(element).closest('.form__group'));
                    }
                } else if (element.attr("type") == "radio") {
                    if ($(element).parents('.radio__error-container')) {
                        error.appendTo($(element).parents('.radio__error-container'));
                    } else {
                        error.appendTo($(element).closest('.form__group'));
                    }
                } else {
                    // something else if it's not a checkbox or radio
                    error.appendTo($(element).closest('.form__group'));
                }
            }

        });

		// Require numbers for fields with data-field-type="number"
        $('[data-field-type="number"]', $certificate_form).rules('add', {
			number: true
		});	
		//});
		
		//IOS FALLBACK FOR GET CERTIFICATE
		$certificate_link = document.getElementById('certificate_link');
		
		if($certificate_link !== undefined) {
			var userAgent = window.navigator.userAgent;
			if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
				$('#certificate_link').show();
				$certificate_form.find(':submit').hide();
				
				$certificate_link.onclick = function() {
					this.href = certificate_form.action;
					var success_markup = '<div class="button button--icon-right button--full-width button--success" disabled><svg class="icon icon--download button__icon button__icon--success" role="presentation" aria-hidden="true"><use href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#check-circle" xlink:href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#check-circle"></use></svg></div>';
					$certificate_form.append(success_markup);
					$('#certificate_link').hide();
					
					$('.content-container--certificate .certificate_divider').hide();
					$('.content-container--certificate .gift_certificate_form').hide();
				}
			}
		}
	}

	//GIFT CERTIFICATE FORM
	var $gift_certificate_form = $("#gift_certificate_form");

	if($gift_certificate_form !== undefined) {
		
		$gift_certificate_form.validate({
			debug: true,
            invalidHandler: function (event, validator) {
	            
            },
            submitHandler: function(form) {
			
				//$gift_certificate_form.submit(function(event) {

				event.preventDefault();
				
				$gift_certificate_form.find(':submit').prop( "disabled", true );
				$gift_certificate_form.find(':submit').addClass('button--loading');
				
				var request_url = $gift_certificate_form.attr('action');
				var options = {
					headers: {
				        "Content-Type": "application/x-www-form-urlencoded",
				    },
					method: 'post',
					body: $gift_certificate_form.serialize()
				}
				
	
				fetch(request_url, options)
				.then(function(response) {
					if(response.status === 200) {
						response.blob().then(function(blob) {
	
							try {
								
								var file_url = window.URL.createObjectURL(blob);
	
								var file_link = document.createElement('a');
								file_link.style.display = 'none';
								file_link.href = file_url;
								file_link.download = 'TERRE-DES-FEMMES_Spendenurkunde-Geschenk.pdf';
								
								//FILENAME OVERRIDE FROM PHP
								/*
								if(response.headers !== undefined) {
									if(response.headers.get("Content-Disposition") !== undefined) {
										
										var buff_file_name = response.headers.get("Content-Disposition");
										buff_file_name = buff_file_name.replace('attachment; filename="', '');
										buff_file_name = buff_file_name.replace('.pdf"', '.pdf');
										if(buff_file_name != null && buff_file_name != '') {
											file_link.download = buff_file_name;
										}
									}
								}
								*/
								
								document.body.appendChild(file_link);
								file_link.click();
	
								window.URL.revokeObjectURL(file_url);
								
								updateForm($gift_certificate_form, 'success', 'gift_certificate_notice', 'Erfolg');
	
							}
							catch(error) {
								updateForm($gift_certificate_form, 'error', 'gift_certificate_notice', 'Fehler');
							}
						});
					}
					else {
						updateForm($gift_certificate_form, 'error', 'gift_certificate_notice', 'Fehler');
					}
				})
				.catch(function(error) {
					updateForm($gift_certificate_form, 'error', 'gift_certificate_notice', 'Fehler');
				});
			},
            errorPlacement: function (error, element) {
                if (element.attr("type") == "checkbox") {
                    if ($(element).parents('.checkbox__error-container')) {
                        error.appendTo($(element).parents('.checkbox__error-container'));
                    } else {
                        error.appendTo($(element).closest('.form__group'));
                    }
                } else if (element.attr("type") == "radio") {
                    if ($(element).parents('.radio__error-container')) {
                        error.appendTo($(element).parents('.radio__error-container'));
                    } else {
                        error.appendTo($(element).closest('.form__group'));
                    }
                } else {
                    // something else if it's not a checkbox or radio
                    error.appendTo($(element).closest('.form__group'));
                }
            }

        });

		// Require numbers for fields with data-field-type="number"
        $('[data-field-type="number"]', $gift_certificate_form).rules('add', {
			number: true
		});	

		//});
		
		
		
		//IOS FALLBACK FOR GIFT CERTIFICATE
		$gift_certificate_link = document.getElementById('gift_certificate_link');
		if($gift_certificate_link !== undefined) {
			var userAgent = window.navigator.userAgent;
			if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
				$('#gift_certificate_link').show();
				$gift_certificate_form.find(':submit').hide();
				
				$gift_certificate_link.onclick = function(event) {
						
					$gifted_error_label = $('#gifted-error');
					if($gifted_error_label !== undefined) {
						
						console.log($gifted_error_label);
						$gifted_error_label.remove();
					}
					var isvalid = false;
						
					var raw_action_link = gift_certificate_form.action;
					
					var action_link_array = raw_action_link.split('&cHash');
					this.href = action_link_array[0];
					
					formvalues = $gift_certificate_form.serializeArray();
					for(var i=0; i<formvalues.length; i++) {
						if(formvalues[i].name === 'tx_lftdf_pdf[newCertificaterequest][gifted]') {	
							if(formvalues[i].value.length > 0) {
								isvalid = true;
								this.href += '&' + formvalues[i].name + '=' + formvalues[i].value;
								break;
							}
						}
					}
					
					if(isvalid === true) {
						$('#gifted').removeClass('error');
						$('#gift_certificate_link').hide();
						var success_markup = '<div class="button button--icon-right button--full-width button--success" disabled><svg class="icon icon--download button__icon button__icon--success" role="presentation" aria-hidden="true"><use href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#check-circle" xlink:href="/frontend/assets/iconsprite/symbol/svg/sprite.symbol.svg#check-circle"></use></svg></div>';
						$gift_certificate_form.append(success_markup);
						
						$('.content-container--certificate .certificate_divider').hide();
						$('.content-container--certificate .certificate_form').hide();
						
					}
					else {
						event.preventDefault();
						$('#gifted').addClass('error');
						$('#gifted_form_group').append('<label id="gifted-error" class="error" for="gifted">Dieses Feld ist ein Pflichtfeld.</label>');
					}
				}
			}
		}	
	}	
	

	//FORM MESSAGES
	function updateForm(form, status, notice_id, message, link) {

		if(form !== undefined) {
			
			var $notice = $('#' + notice_id);
			if($notice !== undefined) {
				$notice.remove();
			}
			
			if(status === 'success') {
				
				/*
				form.find(':submit').attr('disabled','disabled');
				
				if(message !== undefined) {
					form.find(':submit').text(message);
				} else {
					form.find(':submit').text('Success');
				}
				*/
				if ( notice_id === "certificate_notice") {
					
					$('.content-container--certificate .certificate_divider').hide();
					$('.content-container--certificate .gift_certificate_form').hide();
				
				} else if ( notice_id === "gift_certificate_notice") {
					
					$('.content-container--certificate .certificate_divider').hide();
					$('.content-container--certificate .certificate_form').hide();
				}
				
				form.find(':submit').prop( "disabled", true );
				form.find(':submit').removeClass('button--loading');
				form.find(':submit').addClass('button--success');
				
				if(link !== undefined) {
					form.find(':submit').append(link);
				}
				
			} else {

				if(message !== undefined) {
					var notice_text = message;
				}
				else {
					var notice_text = 'Error';
				}

				var notice_markup = '<div id="' + notice_id + '" class="row"><div class="notice mb-4"><div class="col-12 notice__wrap"><div class="notice__text"><p>'+ notice_text +'</p></div></div></div></div>';

				form.append(notice_markup);
				
				$('.content-container--certificate .gift_certificate_form').show();
				$('.content-container--certificate .certificate_divider').show();
				$('.content-container--certificate .certificate_form').show();
				
				form.find(':submit').prop( "disabled", false );
				form.find(':submit').removeClass('button--loading');
				form.find(':submit').removeClass('button--success');
			}
		}

	}

});